<template>
  <div id="websocket" style="display:none;" />
</template>

<script>
export default {
  name: 'Websocket',
  props: {
    source: String,
    path: String,
    callback: Function,
    onConnected: Function,
    onConnectedOnce: Function,
    onDisconnect: Function // Reserved for future use
  },
  data () {
    return {
      connectionCount: 0,
      reconnectInterval: 5000, // 5 seconds
      pingInterval: 30000, // 30 seconds
      sockets: null,
      baseUrl: this.$const.CLIENT_WEBSOCKET_URL[process.env.NODE_ENV][this.$store.getters.config.base.id]
    }
  },
  computed: {},
  mounted () {
    this.initializeSocket()

    // Reconnect if the connection is closed
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
    window.addEventListener('online', this.handleVisibilityChange)
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },
  beforeDestroy () {
    this.disconnect()
  },
  methods: {
    initializeSocket () {
      const vm = this
      // Check if the websocket is available
      if (!this.baseUrl) {
        console.error('Websocket is not available for this client')
        return
      }
      // Create a new WebSocket
      this.socket = new WebSocket(`${this.baseUrl}${this.path}`)
      // Handle error event
      this.socket.onerror = function (error) {
        console.error({
          details: JSON.stringify(error)
        }, 'Error connect to websocket detected')
      }
      // Handle message event
      this.socket.onmessage = function (message) {
        console.log(message, `Receive message from websocket`)
        vm.processMessage(message)
      }
      // Reconnect if the connection is closed
      this.connect()

      // Increase connection count
      vm.connectionCount++

      // Send periodic ping messages to keep the connection alive
      this.ping()
    },
    connect () {
      const vm = this
      this.socket.onopen = function (event) {
        console.log('Connect to websocket opened')
        if (vm.onConnected) {
          vm.onConnected()
        }
        if (vm.onConnectedOnce && vm.connectionCount === 1) {
          vm.onConnectedOnce()
        }
      }
    },
    disconnect () {
      if (this.socket && this.socket.readyState !== WebSocket.CLOSED) {
        this.socket.close()
      }
    },
    handleVisibilityChange() {
      if (document.visibilityState === 'visible' && navigator.onLine) {
        console.log('Browser is visible and online')
        this.disconnect()
        this.initializeSocket()
      } 
      else {
        if (document.visibilityState === 'hidden') {
          console.log('Browser is hidden, will not disconnect the websocket')
        }
        if (!navigator.onLine) {
          console.log('Browser is offline')
          this.disconnect()
        }
      }
    },
    handleBeforeUnload() {
      this.disconnect()
    },
    ping() {
      const vm = this;
      setInterval(() => {
        if (vm.socket && vm.socket.readyState === WebSocket.OPEN) {
          vm.socket.send('ping')
          console.log('Ping message sent to keep the connection alive')
        }
      }, this.pingInterval)
    },
    processMessage (message) {
      try {
        const response = JSON.parse(message.data)
        if (response && response.event) {
          const { data } = response
          const { type, params } = response.event
          const { source } = params
          // console.log(JSON.stringify({ type, source, data }), 'Websocket message content')
          if (this.callback && type == 'get_coupon_log') {
            const decodeData = JSON.parse(Buffer.from(data, 'base64').toString('utf8'))
            this.callback(decodeData)
          }
        }
      } catch (error) {
        console.error('Receive message from websocket has error: ' + error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Websocket.vue